export const carouselRight =
	() => `<svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.46624 3.4454C4.76429 3.75514 4.76429 4.24505 4.46624 4.5548L1.87646 7.24617C1.37712 7.76511 0.5 7.41164 0.5 6.69147L0.5 1.30872C0.5 0.588552 1.37711 0.235085 1.87646 0.754021L4.46624 3.4454Z" fill="inherit"/>
</svg>
`;
